import { NotifyHelper } from "../../../helpers/toast";
import { eBienLaiViewTheoLopActionsObj } from "../../action-types/bien-lai/IBienLaiViewTheoLopActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const bienLaiViewTheoLopActions = {
  ...generateActions(eBienLaiViewTheoLopActionsObj, "BIEN_LAI_VIEW_THEO_LOP"),
  ...generateActionForKey(
    eBienLaiViewTheoLopActionsObj,
    "BIEN_LAI_VIEW_THEO_LOP",
    "HUY_PHIEU_SUCCESS",
    (m) => {
      NotifyHelper.Success("Thành công!");
    }
  ),
  ...generateActionForKey(
    eBienLaiViewTheoLopActionsObj,
    "BIEN_LAI_VIEW_THEO_LOP",
    "HUY_PHIEU_ERR",
    (m) => {
      NotifyHelper.Error(m.data);
    }
  ),
};
